import { useTranslation } from 'react-i18next';
import { Icon, useAppDispatch, useAppSelector } from '../../base';
import { useEffectOnce } from 'react-use';
import { jobApplicationActions, jobApplicationSelectors } from '../../actions';
import { IStatsCard } from '../../common';
import StatsCardsRow from '../StatsCardsRow';

const ApplicationsPageStatistics = () => {
    const { t } = useTranslation();

    const dispatch = useAppDispatch();
    const statistics = useAppSelector(
        jobApplicationSelectors.getJobApplicationsStatistics
    );
    // const isLoading = useSelector(jobsSelectors.getJobsPageStatisticsLoading);

    useEffectOnce(() => {
        dispatch(jobApplicationActions.fetchJobApplicationsStatistics());
    });

    const stats: Array<IStatsCard> = [
        {
            icon: <Icon name="NewCandidatesIcon" size={40} />,
            title: t('applicationsPage.newCandidates'),
            value: statistics?.newApplicants || 0,
            change: {
                value: Math.abs(statistics?.newDifference || 0),
                isPositive: (statistics?.newDifference ?? 0) > 0,
                isZero: statistics?.newDifference === 0,
            },
        },
        {
            icon: <Icon name="CandidatesIcon" size={40} />,
            title: t('applicationsPage.totalCandidates'),
            value: statistics?.totalApplicants || 0,
            change: {
                value: Math.abs(statistics?.totalDifference || 0),
                isPositive: (statistics?.totalDifference ?? 0) > 0,
                isZero: statistics?.totalDifference === 0,
            },
        },
        // {
        //     icon: <Icon name="ClockIcon" size={40} />,
        //     title: t('jobsPage.averageJobOpenings'),
        //     value: `${statistics?.averageJobPublish || 'N/A'} Days`,
        //     //subtitle: 'Updated 10 min ago',
        // },
        {
            icon: <Icon name="ProceededCandidatesIcon" size={40} />,
            title: t('applicationsPage.totalCandidatesInProgress'),
            value: statistics?.proceededApplicants || 0,
            change: {
                value: Math.abs(statistics?.proceededDifference || 0),
                isPositive: (statistics?.proceededDifference ?? 0) > 0,
                isZero: statistics?.proceededDifference === 0,
            },
        },
        {
            icon: <Icon name="RejectedCandidatesIcon" size={40} />,
            title: t('applicationsPage.rejectedCandidates'),
            value: statistics?.rejectedApplicants || 0,
            change: {
                value: Math.abs(statistics?.rejectedDifference || 0),
                isPositive: (statistics?.rejectedDifference ?? 0) > 0,
                isZero: statistics?.rejectedDifference === 0,
            },
        },
    ];

    return <StatsCardsRow stats={stats} />;
};

export default ApplicationsPageStatistics;
